export const Loader = {
    load() {
        const articles = document.getElementById('article')

        if (articles) {
            articles.classList.add('hidden')
        }
        document.getElementById('loading_filters').classList.remove('hidden')
    }
}